import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Product } from '../../../models/products/product';
import { ProductService } from '../../../services/product.service';

@Component({
  selector: 'app-product-create',
  templateUrl: './product-create.component.html',
  styleUrl: './product-create.component.css'
})
export class ProductCreateComponent implements OnInit {
  private productService = inject(ProductService);
  private router = inject(Router);
  private formBuilder = inject(FormBuilder); 
  private breakpointObserver = inject(BreakpointObserver);
  bigScreen = false; 
  
  productForm = this.formBuilder.group({ 
    name: ['', Validators.required],
    description: [''],
    price: ['', [Validators.required, Validators.min(0)]]
  });
  
  ngOnInit(): void {
    this.breakpointObserver.observe(['(max-width: 1500px)']).subscribe(result => {
      this.bigScreen = result.matches;
    });
  }
  
  createProduct() {
    if (this.productForm.invalid) {
      this.productForm.markAllAsTouched();
      return;
    } else {
      let product : Product = {
        id: null,
        name: this.productForm.controls.name.value,
        description: this.productForm.controls.description.value,
        price: +this.productForm.controls.price.value
      }

      this.productService.createProduct(product).subscribe(() =>  {
        this.router.navigate(['/producten']);
      });
    }
  }

  cancel() {
    this.router.navigate(['/producten']);
  }
}
